<template>
    <div class="collapsible" id="controle-etancheite" :class="stateClass">
        <div @click="$emit('openCollapsible', 'controle-etancheite')"
            class="w-full flex items-center justify-between px-4 py-3 rounded-lg cursor-pointer transition select-none mb-5" :class="stateClass === 'open' ? 'bg-gray-700' : 'bg-gray-200'">
            <span class="uppercase font-semibold tracking-wide " :class="stateClass === 'open' ? 'text-white' : 'text-gray-700'">
                CONTRÔLE D'ÉTANCHÉITÉ <span class="text-alert">*</span>
            </span>

            <!-- Flèche dans un rond -->
            <div
                class="w-8 h-8 rounded-full flex items-center justify-center bg-white shadow text-secondary transition">
                <i class="inline-block h-6 w-6 mask mask-arrow-right bg-secondary transition-transform duration-300"
                    :class="stateClass === 'open' ? 'rotate-90' : 'rotate-0'"></i>
            </div>
        </div>

        <div class="collapsible-body my-4" v-show="stateClass === 'open'">

            <div class="head-etanch grid grid-cols-2 gap-3">
                <a href="javascript: void 0" class="detecteur btn-secondary flex items-center gap-2" @click.prevent="openDetec">
                    <i class="icon-look flex-shrink-0"></i>
                    <span class="leading-tight">MON DÉTECTEUR &mdash; MANUEL DE FUITES</span>
                </a>

                <a href="javascript: void 0" class="btn-primary add-fuite" @click.prevent="addFuite">
                    <strong>DÉCLARER</strong> UNE FUITE
                    <i class="icon-add"></i>
                </a>
            </div>


            <div class="checkbox nofuite mt-2" v-show="showNoFuites">
                <input type="checkbox" id="nofuite" name="no_fuite" v-model="no_fuites"
                    @change="$emit('isValidChanged', {isValid, no_fuites})" class="sr-only peer" />
                <label for="nofuite"
                    class="px-4 py-2 rounded-lg text-sm flex items-center justify-center cursor-pointer transition !border-vert border-2"
                    :class="no_fuites ? 'bg-vert text-white' : 'bg-transparent text-vert'">
                    <i class="inline-block h-6 w-6 mask mask-minus mr-2"
                        :class="no_fuites ? 'bg-white' : 'bg-vert'"></i>
                    <span>Aucune fuite à signaler</span>
                </label>
            </div>


            <div class="list-fuites">

                <item-fuite v-for="fuite in fuites" :key="fuite.id" :fuite="fuite" @delFuite="removeFuite(fuite.id)"
                    @fuiteUpdated="updateFuite(fuite)">
                </item-fuite>

            </div>

        </div>
    </div>
</template>

<script>

    import Fuite from '../../../../js/models/Fuite'
    import ItemFuite from './ItemFuite.vue'
    import Offline from "../../../../js/models/Offline";

    export default {

        data() {
            return {
                showDetec: false,
                showNoFuites: true,
                fuites: [],
                no_fuites: null
            }
        },

        props: {
            open: null,
            nofuite: null,
            detecteur: {}
        },

        methods: {
            openDetec() {
                const d = this.detecteur || {};

                // Si ton filtre dateFormat est global, on peut l'appeler comme ça :
                const formattedDate = this.$options.filters && this.$options.filters.dateFormat
                    ? this.$options.filters.dateFormat(d.date_last_controle)
                    : d.date_last_controle;

                swal({
                    title: 'Mon détecteur',
                    text: '', // on met tout dans html
                    html: `
                        <p style="color:#4b5563; margin:0;">
                            <strong>${d.marque || ''} - ${d.modele || ''}</strong><br>
                            ${d.numero_serie ? 'N° de série : <strong>' + d.numero_serie + '</strong><br>' : ''}
                            Dernier contrôle : <strong>${formattedDate || ''}</strong>
                        </p>
                    `,
                    type: 'info', // ou icon: 'info' selon ta version
                    confirmButtonText: 'Fermer'
                });
            },

            fetchFuites(){

                return new Promise((resolve, reject) => {

                    let idFiche = this.$route.params.id;

                    Fuite
                        .getListForFibsdd(idFiche)
                        .then(list => {
                            this.fuites = list.reverse();
                            resolve(true)
                        })
                        .catch(err => reject(err))

                })

            },

            addFuite() {

                if (this.fuites.length === 3) {

                    swal('3 Fuites max', 'Vous ne pouvez déclarer que 3 fuites au maximum', 'info')

                } else {
                    this.no_fuites = false;
                    this.showNoFuites = false;

                    let id = 'F-';
                    let timestamp = '' + +new Date();
                    timestamp = timestamp.slice(7, 12);
                    id = id + timestamp;

                    let idFi = this.$route.params.id;
                    let ordre = this.fuites.length + 1;

                    if(!_.includes(idFi,'N-')){
                        idFi = parseInt(idFi)
                    }

                    let newFuite = {
                        id,
                        dossier: idFi,
                        ordre,
                        localisation: null,
                        etat: null,
                        reparation: null,
                        photo64: null
                    };

                    this.fuites.unshift(newFuite);

                    // AJOUTER DANS LISTFUITES
                    // AJOUTER UN POST FUITE DANS OFFLINEACTIONS
                    Fuite
                        .getList()
                        .then(list => {

                            list.push(newFuite);

                            localforage
                                .setItem('listFuites', JSON.stringify(list))
                                .then()
                                .catch();

                            Offline.saveAction({
                               action: "add",
                               type: 'Fuite',
                               id: newFuite.id
                            });

                            this.$emit('isValidChanged', {isValid: this.isValid, no_fuites: this.no_fuites})

                        })
                        .catch()

                }

            },

            removeFuite(id) {

                if (this.fuites.length === 1) {
                    this.showNoFuites = true
                }

                let indexToDel = _.findIndex(this.fuites, ['id', id]);
                this.fuites.splice(indexToDel, 1);

                if(this.fuites.length !== 0){
                    let length = this.fuites.length;
                    for(let f in this.fuites){
                        this.fuites[f].ordre =  length;
                        length--
                    }

                }

                // DEL FROM LISTFUITES
                // ADD OP DELETE IF ID WAS INT
                Fuite
                    .getList()
                    .then(list => {

                        let indexToDel = _.findIndex(list, ['id', id]);
                        list.splice(indexToDel, 1);

                        localforage
                            .setItem('listFuites', JSON.stringify(list))
                            .then(() => {
                                for(let f in this.fuites){
                                    this.updateFuite(this.fuites[f])
                                }

                            })
                            .catch();

                        // GESTION DES ACTIONS SYNCHRO
                        Offline.deleteAction(id, 'Fuite');
                        if(!_.includes(id,'F-')){
                            Offline.saveAction({
                                action: 'delete',
                                type: 'Fuite',
                                id: id
                            })
                        }

                        this.$emit('isValidChanged', {isValid: this.isValid, no_fuites: this.no_fuites})

                    })
                    .catch(err => reject(err))

            },

            updateFuite(f) {

                Fuite
                    .getList()
                    .then(list => {
                        let indexToUpdt = _.findIndex(list, ['id', f.id]);
                        list[indexToUpdt] = f;
                        localforage.setItem('listFuites', JSON.stringify(list));

                        Offline.saveAction({
                            action: 'update',
                            type: 'Fuite',
                            id: f.id
                        });

                        this.$emit('isValidChanged', {isValid: this.isValid, no_fuites: this.no_fuites})

                    })
                    .catch()
                // UPDATE FUITE IN LISTFUITES
                // ADD OPERATION OFFLINE UPDATE

            },

        },

        computed: {

            stateClass() {
                if (this.open === 'controle-etancheite') {
                    return 'open'
                } else {
                    return ''
                }
            },

            isValid() {

                if (this.fuites.length > 0){
                    let err = true;

                    _.each(this.fuites, f => {
                        if( (f.localisation === null || f.localisation === '') || f.reparation === null){
                            err = false
                        }
                    });

                    return err

                }  else {

                    return this.no_fuites

                }

            }

        },

        mounted() {
            this.no_fuites = this.nofuite;

            this
                .fetchFuites()
                .then(() => {
                    if (this.fuites.length > 0) {
                        this.showNoFuites = false
                    }

                    // JE SAIS PLUS POURQUOI Y AVAIT ÇA AVANT
                    // MAIS ÇA CREE UNE OPÉRATION HORS LIGNE DÈS QU'ON ARRIVE SUR LA PAGE DONC PAS TERRIBLE
                    this.$emit('isValidChanged', {isValid: this.isValid, no_fuites: this.no_fuites})

                })
                .catch()

        },

        components: {

            ItemFuite

        }

    }

</script>


// WEBPACK FOOTER //
// ControlEtanch.vue?60f74746